import React, { memo, Suspense } from 'react'
import LoadingScreen from 'common/components/molecules/LoadingScreen'
import Protected from 'features/auth/ProtectedRoute'
import {
  Route,
  Routes,
  BrowserRouter as Router,
  Navigate,
} from 'react-router-dom'
import ErrorBoundary from 'features/admin/utils/ErrorBoundary'
// import { useHandleLogoutMO } from 'common/hooks/useHandleLogout'
// import { useAppDispatch } from 'common/hooks/state'
// import useIdle from 'common/hooks/useIdleTimer'

const AdminFlow = React.lazy(() => import('features/admin/routes'));
const MemberFlow = React.lazy(() => import('features/client/routes'));
const NotFoundContent = React.lazy(() => import('common/components/molecules/NotFoundContent'));
const SetPassword = React.lazy(() => import('features/auth/pages/set-password'));
const ForgotPassword = React.lazy(() => import('features/auth/pages/forgot-password'));
const ResetPassword = React.lazy(() => import('features/auth/pages/reset-password'));
const QuillPOC = React.lazy(() => import('features/admin/pages/quill-poc'));

const WebRoutes = () => {
  // this code checks user idle timeout
  // const dispatch = useAppDispatch();
  // const onIdle = () => useHandleLogoutMO(dispatch);
  // useIdle({ onIdle, idleTime: 20 });
  return (
    <Suspense fallback={<LoadingScreen isLoading />}>
      <Router>
        <ErrorBoundary>
          <Routes>
            <Route path="/*" element={<MemberFlow />} />
            <Route path="/admin/*" element={<AdminFlow />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/admin/set-password" element={<SetPassword />} />
            <Route path="/admin/" element={<Navigate to="/admin/clients" replace />} />
            <Route path="/quill" element={<QuillPOC />} />
            <Route path="*" element={<NotFoundContent />} />
          </Routes>
        </ErrorBoundary>
      </Router>
    </Suspense>
  )
}

export default memo(WebRoutes)
